// Laravel validation error bags are { field: [message, ...], ... }. Flatten to the first
// message per field, joined for a toast — showing the actual reason (e.g. "Passport must be
// valid for at least 1 year from today") rather than just the field name, since a field can be
// present but still fail validation (expiry too soon, duplicate passport, etc.), not just missing.
export function formatValidationErrors(errors) {
  return Object.values(errors)
    .map((messages) => messages?.[0])
    .filter(Boolean)
    .join(' ');
}
